































import {Component, Vue} from 'vue-property-decorator';

@Component({
    name: 'AppCookie',
})
export default class AppCookie extends Vue {
    protected static setCookie(name: string, value: string) {
        const date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expires = '; expires=' + date.toUTCString();
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    private cookieKey = 'markables.cookie.acceptance';
    private areCookiesAccepted = false;

    public created() {
        if (document.cookie.indexOf(this.cookieKey) >= 0) {
            // They've been here before.
            this.areCookiesAccepted = true;
        }
    }

    protected acceptCookies() {
        AppCookie.setCookie(this.cookieKey, 'true');
        this.areCookiesAccepted = true;
    }
}
